import videojs from 'video.js';
import template from '../templates/error-attach-file.html';

const ModalDialog = videojs.getComponent('ModalDialog');

class ErrorAttachFile extends ModalDialog {
	constructor(player, options) {
		super(player, videojs.mergeOptions(options, { content: getContent('Ошибка при загрузке файла') }));

		this.addListeners_();
	}

	addListeners_() {
		this.on('click', (event) => {
			if (event.target.classList.contains('vjs-error-attach-file__button')) {
				this.close();
			}
		});
	}

	openWithErrorMessage(errorMessage) {
		const modalContent = getContent(errorMessage);
		this.fillWith(modalContent);
		this.open();
	}
}

function getContent(errorMessage) {
	const baseClassName = 'vjs-error-attach-file';
	return videojs.dom.createEl('div', {
		innerHTML: template({ baseClassName, errorMessage }),
		className: baseClassName
	});
}

export { ErrorAttachFile };
